import { render, staticRenderFns } from "./MenuSideBar.vue?vue&type=template&id=3a539300&scoped=true&"
import script from "./MenuSideBar.vue?vue&type=script&lang=js&"
export * from "./MenuSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuSideBar.vue?vue&type=style&index=0&id=3a539300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a539300",
  null
  
)

export default component.exports